<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>

          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>资金发放查询</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="schedule">
            <h2 class="tit8"><span><img src="../../../static/images/guide_sign11.png"> 资金发放查询</span></h2>
            <div class="schedule_sea2">
              <!--  <el-input
                        placeholder="请输身份证号"
                        v-model="person_uid" style="width: 450px;">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                      </el-input>-->
              <template>
                <el-select style="width: 450px" v-model="value" placeholder="请选择">
                  <el-option
                    v-for="item in relationList"
                    :key="item.value"
                    :label="item.name+'（'+item.user_idcard+'）'+item.relation"
                    :value="item.user_idcard_no_occlude">
                  </el-option>
                </el-select>
              </template>
              <el-button type="primary"   @click="searchData"  icon="el-icon-search">搜索</el-button>
              <span style="color: #f56c6c;font-size: 12px;padding-left: 15px">提示：如未绑定人员请在青民通办APP绑定！</span>

            </div>
            <div class="clear"></div>
            <div v-if="!this.$util.isEmpty(data.personUid) && payItemList.length>0">
              <h3 class="details_tit2" style="margin-top: 20px">
                <span style="margin-right: 24px">姓名：{{data.personName}}</span>
                <span style="margin-right: 24px">性别：{{data.personSexName}}</span>
                <span style="margin-right: 24px">身份证号：{{data.personUid}}</span>
              </h3>
              <el-tabs v-if="!this.$util.isEmpty(archive_type_codes)"
                       v-model="active_tab"
                       type="card"
                       @tab-click="tabClick" style="margin-top: 10px;width:90%;margin: 0 auto;">
                <el-tab-pane v-for="(code,index) in archive_type_codes" :key="index" :label="archive_type_names[index]" :name="code"/>
              </el-tabs>
              <table v-if="!this.$util.isEmpty(archive_type_codes)" width="90%" border="0" cellspacing="1" cellpadding="0" class="enjoy_tab"
                     style="margin-left:auto;margin-right:auto;margin-top:10px;float: none">
                <tr class="enjoy_tit">
                  <td width="10%">资金科目</td>
                  <td width="10%">发放金额（元）</td>
                  <td width="10%">发放月份</td>
                  <td width="10%">发放日期</td>
                  <td width="12%">发放银行</td>
                  <td width="15%">卡号</td>
                  <td width="10%">户名</td>
                  <td width="8%">发放状态</td>
                </tr>
                <tr v-for="(item,index) in payItemList" :key="index">
                  <td>{{item.className}}</td>
                  <td>{{item.payAmount}}</td>
                  <td>{{item.payMonth}}</td>
                  <td>{{item.payDate}}</td>
                  <td>{{item.bankName}}</td>
                  <td>{{item.bankAccountCode}}</td>
                  <td>{{item.bankAccountName}}</td>
                  <td>{{item.payStatusName}}</td>
                </tr>
              </table>

            </div>
            <div class="notice_con" v-else>
              <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;"/></div>
                <div style="padding-bottom: 100px">{{message}}</div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "PayList",
    components: {
      headers, fixedDiv, footers
    },
    mounted() {

      this.personUid=this.$route.query.personUid;
      if (this.personUid!=='' && this.personUid!==undefined && this.personUid!==null){
        this.person_uid=this.personUid;
        this.searchData();
      }else {

        var ttt=this;
        this.$https.post("api/pu/peopleUserInfo.do",{},response=> {
          if (response.status === 200 && response.data.code === 200) {
            if (response.data.data.isCertification == '1') {
              ttt.person_uid = response.data.data.userIdcard;
              ttt.flag=1;
              ttt.searchData();
            }
          }
        })
      }
    },
    created() {
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;

      }
      this.selectRelation()
      this.browseLog();
    },
    data() {
      return {
        active_tab: '',
        value: '',
        message: '请输入身份证号查询',
        person_uid: '',
        personUid: '',
        archive_type_codes: [],
        relationList: [],
        archive_type_names: [],
        payItemList: [],
        data: {},
        flag:0,
        loginShow:false,
        gotoIndex:false,
      }
    },
    methods: {
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      selectRelation(){
        const options={
        }
        //查找用户关系
        this.$https.post("api/choice/selectRelationAll.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            this.relationList=response.data.data;
          } else {
            // t.departOption =[];
          }
        })
      },
      browseLog(){
        const options={
          oneCode:'bmcx',
          twoCode:'zjfflscx',
        }
        this.$https.post("api/browse/saveBrowseLog.do",options,response=>{
        })
      },
      searchData() {
        if (!this.$util.isEmpty(this.value)){
          this.person_uid=this.value
        }

        if (this.$util.isEmpty(this.person_uid)) return;
        //清空
        this.archive_type_codes = [];
        this.archive_type_names = [];
        this.payItemList = [];
        this.$https.post("/api/zj/getAllEnjoyTreat.do", {person_uid: this.person_uid}, response => {
          if (response.status === 200 && response.data.code === 200 && response.data.data!==null) {
            this.data = response.data.data;
            let archiveTyeData = this.data.archiveTyeData;
            if (!this.$util.isEmpty(archiveTyeData)) {
              //去掉重复的
              for (let type of archiveTyeData) {
                let type_code = type.archiveTypeCode;
                let type_name = type.archiveTypeName;
                if (this.archive_type_codes.indexOf(type_code) === -1){
                  this.archive_type_codes.push(type_code)
                  this.archive_type_names.push(type_name)
                }
              }
              //默认显示第一个档案的数据，如果有的话
              if (!this.$util.isEmpty(this.archive_type_codes)) {
                this.active_tab=this.archive_type_codes[0];
                this.getPayListItem(this.archive_type_codes[0])
              }
            }else {

              this.message='暂未查询到该人员发放信息！'
            }
          }else {
            if(this.flag==0){
              this.$message.error('暂未查询到该人员发放信息！');
            }else{
              this.flag=0;
            }
          }
        });
      },
      getPayListItem(type_code) {
        this.payItemList = [];
        this.$https.post("/api/zj//getPayList.do", {
          archive_type_code: type_code,
          person_uid: this.person_uid
        }, response => {
          if (response.status === 200 && response.data.code === 200) {
            this.payItemList = response.data.data;
          }
        });
      },
      tabClick(tab) {
        this.getPayListItem(tab.name)
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/usualservice/PayList.vue